// extracted by mini-css-extract-plugin
export var banner = "banner-module--banner--b03d1";
export var bannerContainer = "banner-module--bannerContainer--7d89a";
export var bannerExit = "banner-module--bannerExit--5b948";
export var bannerInfoDescription = "banner-module--bannerInfoDescription--303f6";
export var bannerSection = "banner-module--bannerSection--1592d";
export var btnContainer = "banner-module--btnContainer--23fe2";